//!#system	

<template>
	<v-app>
		<v-layout fill-height>
			<v-navigation-drawer
				permanent
				:mini-variant="navIsMini"
			>

				<v-list class="pt-0" rounded dense nav>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title class="title">
								<v-btn @click="navIsMini = !navIsMini" icon exact small style="margin-left: -5px;">
									<v-icon small>{{ navIsMini ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left' }}</v-icon>
								</v-btn>
								Reports
								<v-btn to="/app/reports" icon exact small>
									<v-icon small>mdi-home</v-icon>
								</v-btn>
							</v-list-item-title>
							<v-list-item-subtitle>
								Data & Visualization
							</v-list-item-subtitle>
							<v-text-field v-model="reportSearch" label="Find reports..." :clearable="true" />
						</v-list-item-content>
					</v-list-item>
					<v-list-item class="mt-2" v-for="report in filteredReports" :key="report.id" :to="'/app/reports/report/' + encodeURIComponent(report.id)">
						<v-list-item-icon>
							<v-icon class="iconWidth">{{ report.icon ? report.icon : 'mdi-table' }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title :title="report.reportCode">{{report.reportCode}}</v-list-item-title>
							<v-list-item-subtitle :title="report.reportDescription">{{report.reportDescription}}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-btn
					fab
					dark
					absolute
					bottom
					left
					small
					color="pink"
					style="bottom: 40px;margin-left: -10px;"
					@click="createWindow = true;"
				>
					<v-icon small>mdi-plus</v-icon>
				</v-btn>
				
			</v-navigation-drawer>
			
			<v-container fluid>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</v-container>

		</v-layout>
		<v-dialog persistent max-width="600px" v-model="createWindow" :key="createWindowKey">
			<create @close="closeCreateWindow" />
		</v-dialog>
	</v-app>
</template>

<script>
import apiService from '@/apiService';
import tools from '@/tools';
import series from 'to-series';
import Create from './app/reporting/ReportDefinitionCreate';
export default {
	components: {
		Create
	},
	data() {
		return {
			isLoading: false,
			reports: [],
			createWindow: false,
			createWindowKey: tools.randomString(),
			navIsMini: false,
			reportSearch: ''
		}
	},
	computed: {
		filteredReports() {
			if (!this.reportSearch) return this.reports;
			const reportSearchLc = this.reportSearch.toLowerCase();
			return this.reports.filter(r => r.reportCode.toLowerCase().includes(reportSearchLc) || r.reportDescription.toLowerCase().includes(reportSearchLc));
		}
	},
	methods: {
		getReportList(done) {
			apiService.list({
				namespace: 'reporting',
				pluralName: 'reportDefinitions'
			}, (err, response) => {
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err.message
					});
				} else {
					this.reports = response;
				}
				return done();
			});
		},
		getInitialData() {
			this.isLoading = true;
			this.getReportList(err => {
				this.isLoading = false;
			});
		},
		closeCreateWindow(args) {
			this.createWindow = false;
			this.createWindowKey = tools.randomString();
			this.getReportList(err => {});
			this.$router.push('/app/reports/report/' + encodeURIComponent(args.id));
		}
	},
	created() {
		this.getInitialData();
	}
}
</script>

<style scoped>
.iconWidth {
	width: 30px;
}
</style>